import { render, staticRenderFns } from "./WebShopRoomColor.vue?vue&type=template&id=f3b45252"
import script from "./WebShopRoomColor.vue?vue&type=script&lang=js"
export * from "./WebShopRoomColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports